var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gradient-block"},[_c('div',{staticClass:"gradient-title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),_c('span',{staticClass:"gradient-title-subtitle"},[_vm._v("\n      "+_vm._s(_vm.subtitle)+"\n    ")])]),_vm._v(" "),(_vm.item.fields.subtitle)?_c('div',[_vm._v("\n    "+_vm._s(_vm.item.fields.subtitle)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }